import { styled } from '@mui/material/styles';
import { TextField } from '../../atoms/TextField';

export const StyledTextField = styled(TextField)`
  max-width: 500px;
`;